export { CoreRoutingModule } from './core-routing.module';
